import { struct } from 'io-ts/Decoder';

import { Id as CanvasId } from '../../../../../whole-house/canvas/Id';
import { Id as GroupId } from '../../../../../whole-house/canvas/recipe-group/Id';

export const Params = struct({
	canvasId: CanvasId,
	recipeGroupId: GroupId,
});
